/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Dual_SubscriptionInputs */

const en_plan_dual_subscription = /** @type {(inputs: Plan_Dual_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have a mobile subscription and a web app subscription. You can cancel one of these without losing any features.`)
};

const es_plan_dual_subscription = /** @type {(inputs: Plan_Dual_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienes una suscripción móvil y una suscripción de la app web. Puedes cancelar una de ellas sin perder ninguna función.`)
};

/**
* | output |
* | --- |
* | "You have a mobile subscription and a web app subscription. You can cancel one of these without losing any features." |
*
* @param {Plan_Dual_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_dual_subscription = /** @type {((inputs?: Plan_Dual_SubscriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Dual_SubscriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_dual_subscription(inputs)
	return en_plan_dual_subscription(inputs)
});